<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-10 18:02 -->
<!-- Description:  -->
<template>
  <div>
    <h4>LISTA DE MENUS</h4>
    <router-link class="btn btn-primary mb-3" :to="{ name: 'admin.menu-create' }">
      Nuevo Menu</router-link>
  
    <div class="mb-3">
      <PermissionSelectFromAll v-model="filters.permission_id"
        @change="$refs.elApirestTable.reload()" placeholder="Permiso"></PermissionSelectFromAll>
    </div>

    <app-apirest-table
      :getList="AdminService.getMenus"
      ref="elApirestTable"
      v-slot:default="slotProps"
      :params="filters"
      >
      <thead>
        <tr>
          <th>#</th>
          <th>Titulo</th>
          <th>Tipo</th>
          <th>Menu P.</th>
          <th>Path</th>
          <th>Permiso</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(l, i) in slotProps.list" :key="i">
          <td>{{ l.id }}</td>
          <td>{{ l.title }}</td>
          <td>{{ l.type }}</td>
          <td>{{ l.menu_id }}</td>
          <td>{{ l.path }}</td>
          <td>{{ l.permission_id }}</td>
          <td>
            <router-link class="btn btn-sm btn-light" :to="{ name: 'admin.menu-edit', params: { id: l.id }}">
              Editar
            </router-link>
            <button class="btn btn-sm btn-danger" @click="deleteItem(l)">
              Eliminar 
            </button>
          </td>
        </tr>
      </tbody>
    </app-apirest-table>
  </div>
</template>
<script>
import AdminService from "../AdminService.js";
import PermissionSelectFromAll from "../permissions/PermissionSelectFromAll.vue";

// script content
export default {
  name: "MenuListView",
  components: {
    PermissionSelectFromAll,
  },

  // directives

  props: {
    //
  },

  data: () => ({
    AdminService,
    filters: {},
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    async deleteItem(item) {
      if( window.confirm("Eliminar registro?") ) {
        await AdminService.deleteMenu(item.id);
        this.$refs.elApirestTable.reload();
      }
    }
    //
    //
  }
};
</script>
<style scoped></style>

